import React from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';

// Image paths are root-relative ('/images/...'), so the old url.resolve() call
// discarded BASE_PATH entirely. Join them explicitly instead.
const withBasePath = (src) => `${BASE_PATH}${src}`.replace(/([^:]\/)\/+/g, '$1');

const Cell = ({ data }) => {
  // Not every project has a link. Render plain markup instead of an empty anchor.
  const title = data.link
    ? <a href={data.link}>{data.title}</a>
    : data.title;

  const image = <img src={withBasePath(data.image)} alt={data.title} />;

  return (
    <div className="cell-container">
      <article className="mini-post">
        <header>
          <h3>{title}</h3>
          {data.subtitle ? <p className="subtitle">{data.subtitle}</p> : null}
          <time className="published">{dayjs(data.date).format('MMMM, YYYY')}</time>
        </header>
        {data.link
          ? <a href={data.link} className="image">{image}</a>
          : <span className="image">{image}</span>}
        <div className="description">
          <p>{data.desc}</p>
        </div>
      </article>
    </div>
  );
};

Cell.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    link: PropTypes.string,
    subtitle: PropTypes.string,
    image: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    desc: PropTypes.string.isRequired,
  }).isRequired,
};

export default Cell;
